import React, { useEffect } from 'react';

import { useProcurement } from '../../context/ProcurementContext';

import { REFETCH_PROCUREMENT_DASHBOARD_EVENT } from './contractDashboardHelpers';
import ContractedVsActualsByType from './ContractedVsActualsByType';
import ContractEndDates from './ContractEndDates';
import ContractKpiTiles from './ContractKpiTiles';
import UnsignedContractTiles from './UnsignedContractTiles';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

import useApiRequest from 'Hooks/useApiRequest';
import { useCustomEvent } from 'Hooks/useGlobalDOMEvents';

/**
 * IB-703 — the redesigned Contract Management → Dashboard sub-tab. Reads the live
 * ContractDashboardService payload and renders KPI tiles, the unsigned callouts, the
 * contracted-vs-actuals utilisation panel and the contract end-dates panel. Mirrors the
 * Overview tab's structure (useApiRequest + REFETCH_PROCUREMENT_DASHBOARD).
 */
const ContractManagementDashboard = () => {
    const { settings, routes } = useProcurement();
    const currencySymbol = settings.currencySymbol;

    const { data, get: fetchDashboard, loading } = useApiRequest({ url: routes.fetchContractDashboardUrl });

    useCustomEvent({
        eventName: REFETCH_PROCUREMENT_DASHBOARD_EVENT,
        onSignal: () => fetchDashboard(),
    });

    useEffect(() => {
        fetchDashboard();
    }, []);

    if (loading && !data) {
        return (
            <div className="tw-rounded-lg tw-bg-white tw-shadow-primary tw-px-6 tw-py-6.5">
                <LoadingSpinner />
            </div>
        );
    }

    const dashboard = data?.dashboard;

    return (
        <div className="tw-flex tw-flex-col tw-gap-6">
            <ContractKpiTiles kpis={dashboard?.kpis} currencySymbol={currencySymbol} />
            <UnsignedContractTiles unsigned={dashboard?.unsigned} currencySymbol={currencySymbol} />
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6">
                <ContractedVsActualsByType byType={dashboard?.by_type} currencySymbol={currencySymbol} />
                <ContractEndDates
                    endDates={dashboard?.end_dates}
                    updateWindowUrl={routes.updateContractEndingSoonWindowUrl}
                    onWindowUpdated={() => fetchDashboard()}
                />
            </div>
        </div>
    );
};

export default ContractManagementDashboard;
